// src/components/banners/BannerContext.jsx
/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const BannerContext = createContext(null);

/**
 * banner shape:
 * {
 *   id: string,
 *   title: string,
 *   message: string,
 *   level: 'info' | 'warning' | 'critical',
 *   sticky: boolean,
 *   daysLeft?: number,
 *   cta?: { label: string, onClick?: () => void }
 * }
 */
export function BannerProvider({ children }) {
  const [banner, setBanner] = useState(null);

  const showBanner = useCallback((b) => {
    const id = crypto.randomUUID?.() || String(Date.now() + Math.random());
    setBanner({ id, level: 'info', sticky: false, ...b });
    return id;
  }, []);

  const hideBanner = useCallback((id) => {
    setBanner((curr) => (curr && (!id || curr.id === id) ? null : curr));
  }, []);

  const value = useMemo(
    () => ({ banner, showBanner, hideBanner }),
    [banner, showBanner, hideBanner]
  );

  return <BannerContext.Provider value={value}>{children}</BannerContext.Provider>;
}

export function useBanner() {
  const ctx = useContext(BannerContext);
  if (!ctx) throw new Error('useBanner deve estar dentro de <BannerProvider>');
  return ctx;
}
